<template>
    <div :style="styleObject"></div>
</template>
<script>
import {getCSSFromStyles} from "@/components/Common/StyleEditor/utils"
export default {
    name : 'rectangle-right-angle',
    props : {
        type : {
            type : String,
            required : true
        },
        shape : {
            type : Object,
            required : true
        }
    },
    computed : {
        styleObject(){
            let shape = this.shape
            let type = this.type
            let temp_styles = {
                border_color : shape.shape_styles.border_color,
                border_width : shape.shape_styles.border_width,
                width : Math.max(shape.shape_styles.width / 8, shape.shape_styles.height / 8),
                height : Math.max(shape.shape_styles.width / 8, shape.shape_styles.height / 8)
            }
            
            let style = {...getCSSFromStyles(temp_styles), position: 'absolute'}

            let border_position_px = `-${shape.shape_styles.border_width || 1}px`
            if(type == "TL"){
                style["left"] = border_position_px
                style["top"] = border_position_px
                if(shape.square.skew_angle){
                    style["border-radius"] = '0% 0% 100% 0%'
                }
            }else if(type == "TR"){
                style["right"] = border_position_px
                style["top"] = border_position_px
                if(shape.square.skew_angle){
                    style["border-radius"] = '0% 0% 0% 1000%'
                }
            }else if(type == "BL"){
                style["left"] = border_position_px
                style["bottom"] = border_position_px
                if(shape.square.skew_angle){
                    style["border-radius"] = '0% 100% 0% 0%'
                }
            }else if(type == "BR"){
                style["right"] = border_position_px
                style["bottom"] = border_position_px
                if(shape.square.skew_angle){
                    style["border-radius"] = '1000% 0% 0% 0%'
                }
            }

            return style
        }
    }
}
</script>
<style></style>